"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TASK = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_TASK = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetTask($id: ID!) {\n    task(id: $id) {\n      ...Task\n    }\n  }\n  ", "\n"], ["\n  query GetTask($id: ID!) {\n    task(id: $id) {\n      ...Task\n    }\n  }\n  ", "\n"])), fragments_1.TASK_FRAGMENT);
var templateObject_1;
